import { fbSaveAlbums, fbSaveStickers } from './firebaseStorage';

const QUEUE_KEY = 'cacafigurinhas:syncQueue';

const loadQueue = () => {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
  } catch {
    return [];
  }
};

const saveQueue = (queue) => {
  try {
    localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
  } catch {}
};

// Enfileira uma operação de sync para ser executada quando houver conexão
export const enqueueSync = (operation) => {
  const queue = loadQueue();
  // Remove duplicata do mesmo tipo + ids antes de adicionar
  const deduped = queue.filter(
    (op) => !(op.type === operation.type && op.userId === operation.userId && op.albumId === operation.albumId)
  );
  deduped.push({ ...operation, enqueuedAt: Date.now() });
  saveQueue(deduped);
};

// Tenta executar todas as operações pendentes
export const drainSyncQueue = async () => {
  if (!navigator.onLine) return;

  const queue = loadQueue();
  if (queue.length === 0) return;

  const remaining = [];
  for (const op of queue) {
    try {
      if (op.type === 'saveAlbums') {
        await fbSaveAlbums(op.userId, op.data);
      } else if (op.type === 'saveStickers') {
        await fbSaveStickers(op.userId, op.albumId, op.data);
      }
    } catch {
      remaining.push(op);
    }
  }
  saveQueue(remaining);
};

// Registra listener para drenar a fila quando a conexão retornar
export const initSyncQueue = () => {
  window.addEventListener('online', drainSyncQueue);
  // Tenta drenar logo ao iniciar, caso haja itens pendentes
  drainSyncQueue();
};
